<div class="wrapper">
  <div class="back-link-container">
    <a routerLink=".." class="back-on-mobile mat-h2">< {{ 'DASHBOARD.MODIFY_DATA' | translate }}</a>
  </div>
  <mat-card class="confinement">
    <mat-card-title class="mat-title">{{ 'ACCOUNT.CHANGE_PASSWORD.TITLE' | translate }}</mat-card-title>
    <mat-card-content>
      <div>
        <p class="email-info-text">
          {{ 'ACCOUNT.CHANGE_PASSWORD.INFO' | translate }}
        </p>
      </div>
      <ng-container *ngIf="formState$ | async as formState">
        <form [ngrxFormState]="formState">
          <div class="form-container">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.CHANGE_PASSWORD.CURRENT_PASSWORD' | translate }}</mat-label>
              <input matInput type="password" [ngrxFormControlState]="formState.controls.oldPassword" />
            </mat-form-field>
            <div class="forgot-password-wrapper">
              <a mat-flat-button class="dark-plain-button" (click)="onForgotPassword()">
                {{ 'ACCOUNT.CHANGE_PASSWORD.FORGOT_PASSWORD' | translate }}
              </a>
            </div>
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.CHANGE_PASSWORD.NEW_PASSWORD' | translate }}</mat-label>
              <input
                matInput
                [type]="passwordIsHidden ? 'password' : 'text'"
                [ngrxFormControlState]="formState.controls.newPassword"
              />
              <mat-icon matSuffix (click)="passwordIsHidden = !passwordIsHidden">{{
                passwordIsHidden ? 'visibility' : 'visibility_off'
              }}</mat-icon>
            </mat-form-field>
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.CHANGE_PASSWORD.REPEAT_PASSWORD' | translate }}</mat-label>
              <input
                matInput
                [type]="repeatPasswordIsHidden ? 'password' : 'text'"
                [ngrxFormControlState]="formState.controls.repeatPassword"
              />
              <mat-icon matSuffix (click)="repeatPasswordIsHidden = !repeatPasswordIsHidden">{{
                repeatPasswordIsHidden ? 'visibility' : 'visibility_off'
              }}</mat-icon>
              <mat-error></mat-error>
            </mat-form-field>
            <div class="submit-button-wrapper">
              <button mat-flat-button color="primary">
                {{ 'ACCOUNT.CHANGE_PASSWORD.SAVE_PASSWORD' | translate }}
              </button>
            </div>
          </div>
        </form>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
